export default {

    names: {
        spin_BUTTON: {
            up: 'SpinButtonNormal.png',
            down: 'SpinButtonDown.png',
            over: 'SpinButtonOver.png',
            disable: 'SpinButtonDisabled.png'
        },
        mobileSpinPortrait_BUTTON: {
            up: 'MobileSpinButtonNormal.png',
            down: 'MobileSpinButtonDown.png',
            over: 'MobileSpinButtonOver.png',
            disable: 'MobileSpinButtonDisabled.png'
        },
        mobileSpinLandscape_BUTTON: {
            up: 'MobileSpinButtonNormal.png',
            down: 'MobileSpinButtonDown.png',
            over: 'MobileSpinButtonOver.png',
            disable: 'MobileSpinButtonDisabled.png'
        },
        stop_BUTTON: {
            up: 'StopSpinButton.png',
            down: 'StopSpinButton.png',
            over: 'StopSpinButton.png',
            disable: 'StopSpinButton.png'
        },
        autoplayStop_BUTTON: {
            up: 'StopButtonNormal.png',
            down: 'StopButtonDown.png',
            over: 'StopButtonOver.png',
            disable: 'StopButtonDisabled.png'
        },
        mobileAutoplayStop_BUTTON: {
            up: 'MobileStopAutoplayButtonNormal.png',
            down: 'MobileStopAutoplayButtonDown.png',
            over: 'MobileStopAutoplayButtonOver.png',
            disable: 'MobileStopAutoplayButtonDisabled.png'
        },
        mobileStopPortrait_BUTTON: {
            up: 'StopSpinButtonMobile.png',
            down: 'StopSpinButtonMobile.png',
            over: 'StopSpinButtonMobile.png',
            disable: 'StopSpinButtonMobile.png'
        },
        mobileStopLandscape_BUTTON: {
            up: 'StopSpinButtonMobile.png',
            down: 'StopSpinButtonMobile.png',
            over: 'StopSpinButtonMobile.png',
            disable: 'StopSpinButtonMobile.png'
        },
        mobileAutoplayPortrait_BUTTON: {
            up: 'MobileAutoplayButtonNormal.png',
            down: 'MobileAutoplayButtonDown.png',
            over: 'MobileAutoplayButtonOver.png',
            disable: 'MobileAutoplayButtonDisabled.png'
        },
        mobileAutoplayLandscape_BUTTON: {
            up: 'MobileAutoplayButtonNormal.png',
            down: 'MobileAutoplayButtonDown.png',
            over: 'MobileAutoplayButtonOver.png',
            disable: 'MobileAutoplayButtonDisabled.png'
        },
        autoplay_BUTTON: {
            up: 'AutoplayButtonNormal.png',
            down: 'AutoplayButtonDown.png',
            over: 'AutoplayButtonOver.png',
            disable: 'AutoplayButtonDisabled.png'
        },
        mobileAutoplayStopPortrait_BUTTON: {
            up: 'MobileStopAutoplayButtonNormal.png',
            down: 'MobileStopAutoplayButtonDown.png',
            over: 'MobileStopAutoplayButtonOver.png',
            disable: 'MobileStopAutoplayButtonDisabled.png'
        },
        mobileAutoplayStopLandscape_BUTTON: {
            up: 'MobileStopAutoplayButtonNormal.png',
            down: 'MobileStopAutoplayButtonDown.png',
            over: 'MobileStopAutoplayButtonOver.png',
            disable: 'MobileStopAutoplayButtonDisabled.png'
        },
        mobileCoinValue_BUTTON: {
            up: 'MobilePortraitCoinValueButtonNormal.png',
            down: 'MobilePortraitCoinValueButtonDown.png',
            over: 'MobilePortraitCoinValueButtonOver.png',
            disable: 'MobilePortraitCoinValueButtonDisabled.png'
        },
        mobileCoinValueLandscape_BUTTON: {
            up: 'MobileLandscapeCoinValueButtonNormal.png',
            down: 'MobileLandscapeCoinValueButtonDown.png',
            over: 'MobileLandscapeCoinValueButtonOver.png',
            disable: 'MobileLandscapeCoinValueButtonDisabled.png'
        },
        bet_BUTTON: {
            up: 'MaxBetButtonNormal.png',
            down: 'MaxBetButtonDown.png',
            over: 'MaxBetButtonOver.png',
            disable: 'MaxBetButtonDisabled.png'
        },
        mobileBet_BUTTON: {
            up: 'MobileBetButtonNormal.png',
            down: 'MobileBetButtonDown.png',
            over: 'MobileBetButtonOver.png',
            disable: 'MobileBetButtonDisabled.png'
        },

        settingsMusic_STATE: {
            states: [
                "MobileToggleOn.png",
                "MobileToggleOff.png"
            ]
        },
        settingsSounds_STATE: {
            states: [
                "MobileToggleOn.png",
                "MobileToggleOff.png"
            ]
        },
        settingsSpace_STATE: {
            states: [
                "MobileToggleOn.png",
                "MobileToggleOff.png"
            ]
        },
        menuBet_STATE: {
            states: [
                "MenuButtons/Bet.png",
                "MenuButtons/BetInactive.png"
            ]
        },
        menuAutoplay_STATE: {
            states: [
                "MenuButtons/Autoplay.png",
                "MenuButtons/AutoplayInactive.png"
            ]
        },
        menuInfo_STATE: {
            states: [
                "MenuButtons/Info.png",
                "MenuButtons/InfoInactive.png"
            ]
        },
        menuBetHistory_STATE: {
            states: [
                "MenuButtons/BetHistory.png",
                "MenuButtons/BetHistoryInactive.png"
            ]
        },
        menuSettings_STATE: {
            states: [
                "MenuButtons/Settings.png",
                "MenuButtons/SettingsInactive.png"
            ]
        },
        menuHome_STATE: {
            states: [
                "MenuButtons/Home.png",
                "MenuButtons/HomeInactive.png"
            ]
        },
        menuTournament_STATE: {
            states: [
                "MenuButtons/Tournament.png",
                "MenuButtons/TournamentInactive.png"
            ]
        },



        plus_BUTTON: {
            up: 'PlusButton.png',
            down: 'PlusButton.png',
            over: 'PlusButton.png',
            disable: 'PlusButton.png'
        },
        mobilePlus_BUTTON: {
            up: 'PlusButtonMobilePortrait.png',
            down: 'PlusButtonMobilePortrait.png',
            over: 'PlusButtonMobilePortrait.png',
            disable: 'PlusButtonMobilePortrait.png'
        },
        minus_BUTTON: {
            up: 'MinusButton.png',
            down: 'MinusButton.png',
            over: 'MinusButton.png',
            disable: 'MinusButton.png'
        },
        mobileMinus_BUTTON: {
            up: 'MinusButtonMobilePortrait.png',
            down: 'MinusButtonMobilePortrait.png',
            over: 'MinusButtonMobilePortrait.png',
            disable: 'MinusButtonMobilePortrait.png'
        },
        menuHome_BUTTON: {
            up: 'MenuButtons/Home.png',
            down: 'MenuButtons/Home.png',
            over: 'MenuButtons/Home.png',
            disable: 'MenuButtons/HomeInactive.png'
        },
        menuAutoplay_BUTTON: {
            up: 'MenuButtons/Autoplay.png',
            down: 'MenuButtons/Autoplay.png',
            over: 'MenuButtons/Autoplay.png',
            disable: 'MenuButtons/AutoplayInactive.png'
        },
        menuBetHistory_BUTTON: {
            up: 'MenuButtons/BetHistory.png',
            down: 'MenuButtons/BetHistory.png',
            over: 'MenuButtons/BetHistory.png',
            disable: 'MenuButtons/BetHistoryInactive.png'
        },
        menuInfo_BUTTON: {
            up: 'MenuButtons/Info.png',
            down: 'MenuButtons/Info.png',
            over: 'MenuButtons/Info.png',
            disable: 'MenuButtons/InfoInactive.png'
        },
        menuSettings_BUTTON: {
            up: 'MenuButtons/Settings.png',
            down: 'MenuButtons/Settings.png',
            over: 'MenuButtons/Settings.png',
            disable: 'MenuButtons/SettingsInactive.png'
        },
        menuTournament_BUTTON: {
            up: 'MenuButtons/Tournament.png',
            down: 'MenuButtons/Tournament.png',
            over: 'MenuButtons/Tournament.png',
            disable: 'MenuButtons/TournamentInactive.png'
        },
        menuBet_BUTTON: {
            up: 'MenuButtons/Bet.png',
            down: 'MenuButtons/Bet.png',
            over: 'MenuButtons/Bet.png',
            disable: 'MenuButtons/BetInactive.png'
        },
        settings_BUTTON: {
            up: 'MobileSettingsIcon.png',
            down: 'MobileSettingsIcon.png',
            over: 'MobileSettingsIcon.png',
            disable: 'MobileSettingsIcon.png'
        },
        mobileSettings_BUTTON: {
            up: 'MobileSettingsIcon.png',
            down: 'MobileSettingsIcon.png',
            over: 'MobileSettingsIcon.png',
            disable: 'MobileSettingsIcon.png'
        },
        info_BUTTON: {
            up: 'InfoButton.png',
            down: 'InfoButton.png',
            over: 'InfoButton.png',
            disable: 'InfoButton.png'
        },
        mobileInfo_BUTTON: {
            up: 'InfoButtonMobilePortrait.png',
            down: 'InfoButtonMobilePortrait.png',
            over: 'InfoButtonMobilePortrait.png',
            disable: 'InfoButtonMobilePortrait.png'
        },
        paytable_BUTTON: {
            up: 'MobileRulesIcon.png',
            down: 'MobileRulesIcon.png',
            over: 'MobileRulesIcon.png',
            disable: 'MobileRulesIcon.png'
        },
        mobilePaytable_BUTTON: {
            up: 'MobileRulesIcon.png',
            down: 'MobileRulesIcon.png',
            over: 'MobileRulesIcon.png',
            disable: 'MobileRulesIcon.png'
        },
        mute_STATE: {
            states: [
                "SoundOnButton.png",
                "SoundOffButton.png"
            ]
        },
        mobileMute_STATE: {
            states: [
                "SoundOnMobilePortrait.png",
                "SoundOffMobilePortrait.png"
            ]
        },
        soundCheckbox_STATE: {
            states: [
                "GeneralSettings/ToggleActive.png",
                "GeneralSettings/ToggleInactive.png"
            ]
        },
        musicCheckbox_STATE: {
            states: [
                "GeneralSettings/ToggleActive.png",
                "GeneralSettings/ToggleInactive.png"
            ]
        },
        spaceToSpinCheckbox_STATE: {
            states: [
                "GeneralSettings/ToggleActive.png",
                "GeneralSettings/ToggleInactive.png"
            ]
        },
        quickSpinCheckbox_STATE: {
            states: [
                "GeneralSettings/ToggleActive.png",
                "GeneralSettings/ToggleInactive.png"
            ]
        },
        fullscreenCheckbox_STATE: {
            states: [
                "GeneralSettings/ToggleActive.png",
                "GeneralSettings/ToggleInactive.png"
            ]
        },
        whenFreespinsCheckbox_STATE: {
            states: [
                "GeneralSettings/ToggleActive.png",
                "GeneralSettings/ToggleInactive.png"
            ]
        },
        whenFreespinsCheckboxPortrait_STATE: {
            states: [
                "MobileAutospinsMenuToggleOn.png",
                "MobileAutospinsMenuToggleOff.png"
            ]
        },
        dropDownSoundRadio_STATE: {
            states: [
                "MobileAutospinsMenuToggleOn.png",
                "MobileAutospinsMenuToggleOff.png"
            ]
        },
        dropDownMusicRadio_STATE: {
            states: [
                "MobileAutospinsMenuToggleOn.png",
                "MobileAutospinsMenuToggleOff.png"
            ]
        },
        dropDownSpaceToSpinRadio_STATE: {
            states: [
                "MobileAutospinsMenuToggleOn.png",
                "MobileAutospinsMenuToggleOff.png"
            ]
        },
        dropDownQuickSpinRadio_STATE: {
            states: [
                "MobileAutospinsMenuToggleOn.png",
                "MobileAutospinsMenuToggleOff.png"
            ]
        },
        dropDownFullscreenRadio_STATE: {
            states: [
                "MobileAutospinsMenuToggleOn.png",
                "MobileAutospinsMenuToggleOff.png"
            ]
        },
        betCell_STATE: {
            states: [
                "PinkContainerSectionActive.png",
                "BetContainerSectionInactive.png"
            ]
        },
        settingClose_BUTTON: {
            up: 'CloseButton.png',
            down: 'CloseButton.png',
            over: 'CloseButton.png',
            disable: 'CloseButton.png'
        },
        settingPlay_BUTTON: {
            up: 'PlayButtonNormal.png',
            down: 'PlayButtonDown.png',
            over: 'PlayButtonOver.png',
            disable: 'PlayButtonNormal.png'
        },
        settingsSingleWinMinus_BUTTON: {
            up: 'GeneralSettings/MinusButtonNormal.png',
            down: 'GeneralSettings/MinusButtonDown.png',
            over: 'GeneralSettings/MinusButtonOver.png',
            disable: 'GeneralSettings/MinusButtonDisabled.png'
        },
        settingsSingleWinMinusPortrait_BUTTON: {
            up: 'MobileAutospinsettingsDecreaseButtonNormal.png',
            down: 'MobileAutospinsettingsDecreaseButtonDown.png',
            over: 'MobileAutospinsettingsDecreaseButtonDisabled.png',
            disable: 'MobileAutospinsettingsDecreaseButtonDisabled.png'
        },
        settingsCashIncreaseMinus_BUTTON: {
            up: 'GeneralSettings/MinusButtonNormal.png',
            down: 'GeneralSettings/MinusButtonDown.png',
            over: 'GeneralSettings/MinusButtonOver.png',
            disable: 'GeneralSettings/MinusButtonDisabled.png'
        },
        settingsCashIncreaseMinusPortrait_BUTTON: {
            up: 'MobileAutospinsettingsDecreaseButtonNormal.png',
            down: 'MobileAutospinsettingsDecreaseButtonDown.png',
            over: 'MobileAutospinsettingsDecreaseButtonDown.png',
            disable: 'MobileAutospinsettingsDecreaseButtonDisabled.png'
        },
        settingsCashDecreaseMinus_BUTTON: {
            up: 'GeneralSettings/MinusButtonNormal.png',
            down: 'GeneralSettings/MinusButtonDown.png',
            over: 'GeneralSettings/MinusButtonOver.png',
            disable: 'GeneralSettings/MinusButtonDisabled.png'
        },
        settingsCashDecreaseMinusPortrait_BUTTON: {
            up: 'MobileAutospinsettingsDecreaseButtonNormal.png',
            down: 'MobileAutospinsettingsDecreaseButtonDown.png',
            over: 'MobileAutospinsettingsDecreaseButtonDown.png',
            disable: 'MobileAutospinsettingsDecreaseButtonDisabled.png'
        },
        settingsSingleWinPlus_BUTTON: {
            up: 'GeneralSettings/PlusButtonNormal.png',
            down: 'GeneralSettings/PlusButtonDown.png',
            over: 'GeneralSettings/PlusButtonOver.png',
            disable: 'GeneralSettings/PlusButtonDisabled.png'
        },
        settingsCashIncreasePlus_BUTTON: {
            up: 'GeneralSettings/PlusButtonNormal.png',
            down: 'GeneralSettings/PlusButtonDown.png',
            over: 'GeneralSettings/PlusButtonOver.png',
            disable: 'GeneralSettings/PlusButtonDisabled.png'
        },
        settingsCashIncreasePlusPortrait_BUTTON: {
            up: 'MobileAutospinsettingsIncreaseButtonNormal.png',
            down: 'MobileAutospinsettingsIncreaseButtonDown.png',
            over: 'MobileAutospinsettingsIncreaseButtonDown.png',
            disable: 'MobileAutospinsettingsIncreaseButtonDisabled.png'
        },
        settingsSingleWinPortraitPlus_BUTTON: {
            up: 'MobileAutospinsettingsIncreaseButtonNormal.png',
            down: 'MobileAutospinsettingsIncreaseButtonDown.png',
            over: 'MobileAutospinsettingsIncreaseButtonDown.png',
            disable: 'MobileAutospinsettingsIncreaseButtonDisabled.png'
        },
        settingsCashDecreasePlus_BUTTON: {
            up: 'GeneralSettings/PlusButtonNormal.png',
            down: 'GeneralSettings/PlusButtonDown.png',
            over: 'GeneralSettings/PlusButtonOver.png',
            disable: 'GeneralSettings/PlusButtonDisabled.png'
        },
        settingsCashDecreasePlusPortrait_BUTTON: {
            up: 'MobileAutospinsettingsIncreaseButtonNormal.png',
            down: 'MobileAutospinsettingsIncreaseButtonDown.png',
            over: 'MobileAutospinsettingsIncreaseButtonDown.png',
            disable: 'MobileAutospinsettingsIncreaseButtonDisabled.png'
        },
        dropDownMenu_BUTTON: {
            up: 'MobileMenuIcon.png',
            down: 'MobileMenuIcon.png',
            over: 'MobileMenuIcon.png',
            disable: 'MobileMenuIcon.png'
        },
        dropDownMenuGeneralSettings_BUTTON: {
            up: 'MobileMenuIcon.png',
            down: 'MobileMenuIcon.png',
            over: 'MobileMenuIcon.png',
            disable: 'MobileMenuIcon.png'
        },
        dropDownHome_BUTTON: {
            up: 'HomeIcon.png',
            down: 'HomeIcon.png',
            over: 'HomeIcon.png',
            disable: 'HomeIcon.png'
        },
        dropDownPaytable_BUTTON: {
            up: 'alpha40x800.png',
            down: 'alpha40x800.png',
            over: 'alpha40x800.png',
            disable: 'alpha40x800.png'
        },
        dropDownPaytableLandscape_BUTTON: {
            up: 'alpha40x300.png',
            down: 'alpha40x300.png',
            over: 'alpha40x300.png',
            disable: 'alpha40x300.png'
        },
        dropDownSettings_BUTTON: {
            up: 'alpha40x800.png',
            down: 'alpha40x800.png',
            over: 'alpha40x800.png',
            disable: 'alpha40x800.png'
        },
        dropDownSettingsLandscape_BUTTON: {
            up: 'alpha40x300.png',
            down: 'alpha40x300.png',
            over: 'alpha40x300.png',
            disable: 'alpha40x300.png'
        },
        dropDownGameRules_BUTTON: {
            up: 'alpha40x800.png',
            down: 'alpha40x800.png',
            over: 'alpha40x800.png',
            disable: 'alpha40x800.png'
        },
        dropDownGameRulesLandscape_BUTTON: {
            up: 'alpha40x300.png',
            down: 'alpha40x300.png',
            over: 'alpha40x300.png',
            disable: 'alpha40x300.png'
        },
        generalSettingsArrowBack_BUTTON: {
            up: 'MobileBackArrow.png',
            down: 'MobileBackArrow.png',
            over: 'MobileBackArrow.png',
            disable: 'MobileBackArrow.png'
        },
        plusAutospinsPortrait_BUTTON: {
            up: 'MobilePlusButtonNormal.png',
            down: 'MobilePlusButtonDown.png',
            over: 'MobilePlusButtonDown.png',
            disable: 'MobilePlusButtonDisabled.png'
        },
        plusBetPortrait_BUTTON: {
            up: 'MobilePlusButtonNormal.png',
            down: 'MobilePlusButtonDown.png',
            over: 'MobilePlusButtonDown.png',
            disable: 'MobilePlusButtonDisabled.png'
        },
        plusBetLandscape_BUTTON: {
            up: 'MobilePlusButtonNormal.png',
            down: 'MobilePlusButtonDown.png',
            over: 'MobilePlusButtonDown.png',
            disable: 'MobilePlusButtonDisabled.png'
        },
        minusAutospinsPortrait_BUTTON: {
            up: 'MobileMinusButtonNormal.png',
            down: 'MobileMinusButtonDown.png',
            over: 'MobileMinusButtonDown.png',
            disable: 'MobileMinusButtonDisabled.png'
        },
        minusBetLandscape_BUTTON: {
            up: 'MobileMinusButtonNormal.png',
            down: 'MobileMinusButtonDown.png',
            over: 'MobileMinusButtonDown.png',
            disable: 'MobileMinusButtonDisabled.png'
        },
        minusBetPortrait_BUTTON: {
            up: 'MobileMinusButtonNormal.png',
            down: 'MobileMinusButtonDown.png',
            over: 'MobileMinusButtonDown.png',
            disable: 'MobileMinusButtonDisabled.png'
        },
        autospinStartPortrait_BUTTON: {
            up: 'MobileGenericButton.png',
            down: 'MobileGenericButton.png',
            over: 'MobileGenericButton.png',
            disable: 'MobileGenericButton.png'
        },
        betSettingConfirmPortrait_BUTTON: {
            up: 'MobileGenericButton.png',
            down: 'MobileGenericButton.png',
            over: 'MobileGenericButton.png',
            disable: 'MobileGenericButton.png'
        },
        autospinCancelPortrait_BUTTON: {
            up: 'alpha40x300.png',
            down: 'alpha40x300.png',
            over: 'alpha40x300.png',
            disable: 'alpha40x300.png'
        },
        betSettingCancelPortrait_BUTTON: {
            up: 'alpha40x300.png',
            down: 'alpha40x300.png',
            over: 'alpha40x300.png',
            disable: 'alpha40x300.png'
        },
        paytableRightArrow_BUTTON: {
            up: 'paytable/PaytableArrowRight.png',
            down: 'paytable/PaytableArrowRight.png',
            over: 'paytable/PaytableArrowRight.png',
            disable: 'paytable/PaytableArrowRight.png'
        },
        paytableLeftArrow_BUTTON: {
            up: 'paytable/PaytableArrowLeft.png',
            down: 'paytable/PaytableArrowLeft.png',
            over: 'paytable/PaytableArrowLeft.png',
            disable: 'paytable/PaytableArrowLeft.png'
        },
        paytableClose_BUTTON: {
            up: 'paytable/PaytableCloseButtonNormal.png',
            down: 'paytable/PaytableCloseButtonDown.png',
            over: 'paytable/PaytableCloseButtonOver.png',
            disable: 'paytable/PaytableCloseButtonDown.png'
        },
        menu: {
            states: [
                "MenuButtonsContainerClosed.png",
                "MenuButtonsContainerOpen.png"
            ]
        },
        AutoplayValues: {
            styleUp: 'autoplayValues25',
            styleDown: 'autoplayValues25',
            styleOver: 'autoplayValues25',
            texture: 'AutoSlider.png'
        },
        autoplayCounter: {
            up: 'AutoplayCounterButton.png',
            down: 'AutoplayCounterButton.png',
            over: 'AutoplayCounterButton.png',
            disable: 'AutoplayCounterButton.png'
        },
        mobileAutoplayCounter: {
            up: 'MobileAutoPlayCounterNormal.png',
            down: 'MobileAutoPlayCounterDown.png',
            over: 'MobileAutoPlayCounterOver.png',
            disable: 'MobileAutoPlayCounterDisabled.png'
        },
        lines_BITMAP: {
            texture: 'LinesContainer.png'
        },
        settingsBack_BITMAP: {
            texture: 'GeneralSettings/PopUpWindow_Generic.png'
        },
        coinValue_BITMAP: {
            texture: 'CoinValueContainer.png'
        },
        bet_BITMAP: {
            texture: 'BetContainerBack.png'
        },
        autoStopCounter_BITMAP: {
            texture: 'MobileGenericButton.png'
        },

        balance_BITMAP: {
            texture: 'BalanceContainer.png'
        },
        win_BITMAP: {
            texture: 'WinContainer.png'
        },
        mobileWin_BITMAP: {
            texture: 'MobileWinContainer.png'
        },
        settingsInput1_BITMAP: {
            texture: 'GeneralSettings/SettingsScreenContainer.png'
        },
        settingsInput2_BITMAP: {
            texture: 'GeneralSettings/SettingsScreenContainer.png'
        },
        settingsInput3_BITMAP: {
            texture: 'GeneralSettings/SettingsScreenContainer.png'
        },
        settingsInput1Portrait_BITMAP: {
            texture: 'MobileAutospinsettingsContainer.png'
        },
        settingsInput2Portrait_BITMAP: {
            texture: 'MobileAutospinsettingsContainer.png'
        },
        settingsInput3Portrait_BITMAP: {
            texture: 'MobileAutospinsettingsContainer.png'
        },
        dropDownPaytable_BITMAP: {
            texture: 'MobileInfoIcon.png'
        },
        dropDownSettings_BITMAP: {
            texture: 'MobileSettingsIcon.png'
        },
        dropDownGameRules_BITMAP: {
            texture: 'MobileRulesIcon.png'
        },
        buttonsBackPortrait_IMAGE: {
            texture: 'ButtonBackground.png'
        },
        buttonsBackLand_IMAGE: {
            texture: 'MobileLandscapeButtonBackground.png'
        },
        backButtonsDesktop_IMAGE: {
            texture: 'DesktopUiBorder.png'
        },
        fsBackButtonsDesktop_BITMAP: {
            texture: 'FreeSpinsUi.png'
        },
        fsBackButtonsPortrait_BITMAP: {
            texture: 'MobileFreeSpinsUi.png'
        },
        fsBackButtonsLandscape_BITMAP: {
            texture: 'LandscapeFreeSpinsUi.png'
        },
        paytableBack_BITMAP: {
            texture: 'paytable/PaytableInfoScreenBackground.jpg'
        },
        portraitPaytableBack_BITMAP: {
            texture: 'paytable/PortraitPaytableBackground.jpg'
        },
        daniel_BITMAP: {
            texture: 'GeneralSettings/daniel.png'
        },
        decorBuyFeatureMobile_BITMAP: {
            texture: 'buyFeature/decorBuyFeatureMobile.png'
        },


        betHistoryMobile_BUTTON: {
            up: 'betHistoryMobile.png',
            down: 'betHistoryMobile.png',
            over: 'betHistoryMobile.png',
            disable: 'betHistoryMobile.png'
        },
        mobileAutoplay_BUTTON: {
            up: 'MobilePortraitAutoplayNormal.png',
            down: 'MobilePortraitAutoplayDown.png',
            over: 'MobilePortraitAutoplayOver.png',
            disable: 'MobilePortraitAutoplayDisabled.png'
        },

        sound_STATE: {
            states: [
                "SoundOnButton.png",
                "SoundOffButton.png"
            ]
        },
        mobileSound_STATE: {
            states: [
                "SoundOnMobilePortrait.png",
                "SoundOffMobilePortrait.png"
            ]
        },
        decorBuyFeature_BITMAP: {
            texture: 'buyFeature/decorBuyFeature.png'
        },
        UIStrip_BITMAP: {
            texture: 'UiStrp.png'
        },
        UiStripMobilePortrait_BITMAP: {
            texture: 'UiStripMobilePortrait.png'
        },
        UiStripMobileLandscape_BITMAP: {
            texture: 'UiStrp.png'
        },
        menu_BUTTON: {
            up: 'MenuButton.png',
            down: 'MenuButton.png',
            over: 'MenuButton.png',
            disable: 'MenuButton.png'
        },
        mobileMenu_BUTTON: {
            up: 'MenuButtonMobilePortrait.png',
            down: 'MenuButtonMobilePortrait.png',
            over: 'MenuButtonMobilePortrait.png',
            disable: 'MenuButtonMobilePortrait.png'
        }

    }
}